// Meta Pixel event mapping (spec §4.3).

export const META_PIXEL_ID = '1093256550318655';

export const META_CLICK_EVENTS: Readonly<Record<string, string>> = {
  start_free_click: 'StartFreeClick',
  demo_request_click: 'DemoRequestClick',
  pricing_click: 'PricingClick',
};

// Locale prefixes are two letters or `zh-hant` (data/locales.ts).
export function isPricingPath(path: string): boolean {
  return /^\/(?:[a-z]{2}(?:-[a-z]{2,4})?\/)?pricing\/?$/i.test(path);
}

/**
 * The paid-ad redirect hops (/start, /ios), which exist only to fire the Pixel before handing the
 * visitor on and leave again within ~1.5s.
 *
 * plugins/cookie-consent.client.ts defers tags to idle so third-party JS never blocks LCP/TTI on a
 * real page, but `requestIdleCallback`'s 3s timeout is longer than the hop waits, so on these two
 * routes the Pixel was still uninjected when the page left. Desktop recorded 12 landing page views
 * against 52 outbound clicks because of it; iPhone escaped only because an apps.apple.com hop hands
 * off without tearing the page down, letting the Pixel finish loading in the background.
 */
export function isRedirectPath(path: string): boolean {
  return /^\/(?:[a-z]{2}(?:-[a-z]{2,4})?\/)?(?:start|ios)\/?$/i.test(path);
}
